import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const ReactiveDataWidget: WidgetRegistryEntry = {
  name: "ReactiveData",
  configuration: () => import("./configuration").then((m) => m.ReactiveDataWidgetConfiguration),
  component: () => import("./reactive-data-widget.component").then((m) => m.ReactiveDataWidgetComponent)
};
